module.exports = __webpack_public_path__ + "img/placeholder.be02b1eb.png";